import React, { useState, useEffect, useRef, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Badge, Modal, Tab, Tabs, Stack, Button, Form, Accordion, ModalTitle, Card } from 'react-bootstrap';
import { faPlus, faXmark, faPencil, faPaperclip, faCalendarDays, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Skeleton from '@mui/material/Skeleton';
import '../../../../assets/css/Trucker/overview/trucker_overview.scss';
import '../../../../assets/css/RFSmonitor/rfsmonitor.scss';
import { ReactComponent as Car } from "../../../../assets/images/icon_svg/car_timline.svg";
import { ReactComponent as CurvLeft } from "../../../../assets/images/icon_svg/line_curv.svg";
import { ReactComponent as CarvRight } from "../../../../assets/images/icon_svg/line_curv_right.svg";
import { ReactComponent as Plus } from "../../../../assets/images/icon_svg/plus.svg";
import { ReactComponent as Warning } from '../../../../assets/images/icon_svg/warning.svg';
import { ReactComponent as GrayCalnder } from '../../../../assets/images/icon_svg/grayCalnder.svg'; 
import { ReactComponent as ArrowCircle } from '../../../../assets/images/icon_svg/arww_wth_crcl.svg'; 
import { faDownload, } from '@fortawesome/free-solid-svg-icons';
import { CallApi, CommonModal, getTodayDateTime } from '../../../../Components/common/CommonFunctions';
import { Remarks, RemarksForm } from '../../../../Components/common/Remarks';
import Select from "react-select"
import { toast } from 'react-toastify';
import DiscrepancyModal from './DiscrepancyModal';

const Overview = ({ propData, onReload, onDetails, loading = false }) => {
  const discrepancies = propData?.discrepancies || [];
  const [selectedDiscrepancy, setSelectedDiscrepancy] = useState(null);
  const [timeComp, setTimeComp] = useState([])
  const [remarksData, setRemarksData] = useState({})
  const [descrepencyModal,setOpenDiscrepencyModal] = useState(false);

  const [openModal, setOpenModal] = useState(false)
  const [editData, setEditData] = useState();
  const addRemarks = () => setOpenModal(true)
  const modalClose = () => {
    setOpenModal(false)
  }

  // Treat data as still loading if the loading flag is explicitly set,
  // or if propData hasn't arrived yet.
  const isLoading = loading || !propData;

  useEffect(() => {
    if (propData?.planned_time_comparison) {
      const comData = Object.entries(propData?.planned_time_comparison)?.map(([key, data], index) => {
        return {
          name: key,
          airline_planning:
            ['STA', 'STD'].includes(key)
              ? data.airline_planning
                ? data.airline_planning
                : null
              : key === 'Volume'
                ? data.airline_planning != null
                  ? data.airline_planning + ' m³'
                  : null
                : data.airline_planning,
          is_different: data.is_different,
          trucker_planning:
            ['STA', 'STD'].includes(key)
              ? data.trucker_planning
                ? data.trucker_planning
                : null
              : key === 'Volume'
                ? data.trucker_planning != null
                  ? data.trucker_planning + ' m³'
                  : null
                : data.trucker_planning
        }
      })
      setTimeComp(comData)
    }
    if (propData) {
      setRemarksData({
        id: propData.id,
        attType: 'airline_truck_order',
        comments: propData.comments
      })
    }
  }, [propData])
  const sendData = { id: propData?.id, attType: 'airline_truck_order' }

  const handleReload = () => {
    onReload()
    setOpenModal(false)
  }

  const handleOpenModal = (item) =>{
    setSelectedDiscrepancy(item);
    setOpenDiscrepencyModal(true);
  }

  const closeDescrepencyModal = ()=>{
    setOpenDiscrepencyModal(false);
    setSelectedDiscrepancy(null);
  }

  // ---- Skeleton building blocks ----

  const TimelineSkeleton = () => (
    <div className="timeline-wrapper">
      <div className="timeline">
        {Array.from({ length: 6 }).map((_, i) => (
          <div className="step" key={`tl-skel-${i}`}>
            <Skeleton variant="circular" width={16} height={16} sx={{ mb: 1 }} />
            <Skeleton variant="text" width={70} height={16} />
            <Skeleton variant="text" width={90} height={14} />
          </div>
        ))}
        <div className="etapart">
          <Skeleton variant="rounded" width={120} height={40} />
        </div>
        {Array.from({ length: 2 }).map((_, i) => (
          <div className="step" key={`tl-skel-end-${i}`}>
            <Skeleton variant="circular" width={16} height={16} sx={{ mb: 1 }} />
            <Skeleton variant="text" width={70} height={16} />
          </div>
        ))}
      </div>
    </div>
  );

  const PlanningComparisonSkeleton = () => (
    <div className="tw-33 summary_card min-hgt-55">
      <div className="rfstrckovrvw">
        <h6>Planning Comparison</h6>
        <p>Comparison between planning airline and trucker.</p>
      </div>
      <div className="table-wrapper table-responsive">
        <table className="truck_order_details_table table">
          <thead>
            <tr>
              <th></th>
              <th>Airline Planning</th>
              <th>Trucker Planning</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 6 }).map((_, i) => (
              <tr key={`pc-skel-${i}`}>
                <td><Skeleton variant="text" width={80} /></td>
                <td><Skeleton variant="text" width={100} /></td>
                <td><Skeleton variant="text" width={100} /></td>
                <td><Skeleton variant="circular" width={16} height={16} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const DiscrepanciesSkeleton = () => (
    <div className="tw-33 summary_card min-hgt-55">
      <div className="rfstrckovrvw">
        <h6>Discrepancies</h6>
        <p>Issues detected in planning, execution, or shipments</p>
      </div>
      <div className='max-hgt-45'>
        {Array.from({ length: 3 }).map((_, i) => (
          <div className="topRedbordrBx" key={`disc-skel-${i}`}>
            <Skeleton variant="text" width="60%" height={22} />
            <Skeleton variant="text" width="90%" />
            <div className="borderBottom"></div>
            <div className="d-flex align-items-center gap-2">
              <Skeleton variant="rounded" width={90} height={22} />
              <Skeleton variant="rounded" width={60} height={22} />
              <Skeleton variant="circular" width={20} height={20} sx={{ ml: 'auto' }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const RemarksSkeleton = () => (
    <div className='tw-33 summary_card min-hgt-55 remarks_tab'>
      <div className='rfstrckovrvw position-relative'>
        <h6>Remarks</h6>
        <p>Add and manage truck order notes</p>
      </div>
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={`rem-skel-${i}`} className="d-flex flex-column gap-1 mt-3">
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="text" width="95%" />
          <Skeleton variant="text" width="70%" />
        </div>
      ))}
    </div>
  );

  if (isLoading) {
    return (
      <>
        <TimelineSkeleton />
        <div className='d-flex gap-3 mt-3'>
          <PlanningComparisonSkeleton />
          <DiscrepanciesSkeleton />
          <RemarksSkeleton />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="timeline-wrapper">
        <div className="timeline">
          {/* Step 1 */}
          <div className={`step ${propData?.timeBar?.loading_shipments_received?.color}`}>
            <div className="circle" />
            <div className="truck_time">{propData?.timeBar?.loading_shipments_received?.time?.toUpperCase()}</div>
            <div className="truck_label">Shipments Received</div>
            <div className="truck_status">{propData?.timeBar?.loading_shipments_received?.count}</div>
          </div>
          {/* Step 2 */}
          <div className={`step ${propData?.timeBar?.manifested?.color}`}>
            <div className="circle" />
            <div className="truck_time">{propData?.timeBar?.manifested?.time?.toUpperCase()}</div>
            <div className="truck_label">Manifested</div>
            <div className="truck_status">{propData?.timeBar?.manifested?.count}</div>
          </div>
          {/* Step 4 */}
          <div className={`step ${propData?.timeBar?.loading_started?.color}`}>
          <div className="circle" />
          <div className="truck_time">
              {propData?.timeBar?.loading_started?.time}
        </div>
          <div className="truck_label">Loading Started</div>
          </div>
          {/* Step 5 */}
         <div className={`step ${propData?.timeBar?.loading_completed?.color}`}>
          <div className="circle" />
          <div className="truck_time">
            {propData?.timeBar?.loading_completed?.time}
          </div>
          <div className="truck_label">Loading Completed</div>
        </div>
          {/* Step 6 */}
          <div className={`step ${propData?.timeBar?.departed?.color}`}>
            <div className="circle" />
            <div className="truck_time">{propData?.timeBar?.departed?.time}</div>
            <div className="truck_label">Departed</div>
            <div className="truck_status">{propData?.timeBar?.departed?.count}</div>
          </div>
          {/* Step 7 */}
          <div className="etapart">
            <div className='curv_left'><CurvLeft /></div>
            <div className="car">
              <span className="carbox"><Car /></span>
              <span className="carbox"><Car /></span>
            </div>
            <div className='carv_right'><CarvRight /></div>
            <div className={`truck_label ${propData?.timeBar?.eta_date?.color}`}>
              ETA {propData?.timeBar?.eta_date?.time ?? "-"}
            </div>
          </div>
          {/* Step 8 */}
          <div className="step">
            <div className="circle" />
            <div className="truck_time">{propData?.timeBar?.truck_arrived?.time}</div>
            <div className="truck_label">Truck Arrived</div>
          </div>
          {/* Step 9 */}
          <div className="step">
            <div className="circle" />
            <div className="truck_time">{propData?.timeBar?.unloading_shipments_received?.time}</div>
            <div className="truck_label">Shipments Received</div>
          </div>
        </div>
      </div>

      <div className='d-flex gap-3 mt-3'>
        <div className='tw-33 summary_card min-hgt-55'>
          <div className='rfstrckovrvw'>
            <h6>Planning Comparison</h6>
            <p>Comparison between planning airline and trucker.</p>
          </div>
          <div className="table-wrapper table-responsive">
            <table className="truck_order_details_table table">
              <thead>
                <tr>
                  <th></th>
                  <th>Airline Planning</th>
                  <th>Trucker Planning</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {timeComp?.map((tc, index) => (
                  <tr key={tc.name + index}>
                    <td>{tc.name}</td>
                    <td>{tc.airline_planning}</td>
                    <td>{tc.trucker_planning}</td>
                    <td>{tc.is_different ? <Warning /> : ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="tw-33 summary_card min-hgt-55">
          <div className="rfstrckovrvw">
            <h6>Discrepancies</h6>
            <p>Issues detected in planning, execution, or shipments</p>
          </div>
          {discrepancies.length === 0 ? (
            <div className="text-center no_item_text">
              No discrepancies detected.
            </div>
          ) : (
            <div className='max-hgt-45'>
            {discrepancies.map((item) => (
              <div className="topRedbordrBx" key={item.id}>
                <h5>{item.list?.title}</h5>
                <p>{item.list?.description}</p>
                <div className="borderBottom"></div>
                <div className="d-flex align-items-center gap-2">
                  <span className="graybg_text">
                    <GrayCalnder />
                    {item.list?.identified_on}
                  </span>
                  {item.list?.badge?.value && (
                    <span className="redbg_text">
                      {item.list.badge.value?.replace(/difference/gi, '').trim()}
                    </span>
                  )}
                  <span onClick={() => handleOpenModal(item)} className="ms-auto">
                    <ArrowCircle />
                  </span>
                </div>
              </div>
            ))}
            </div>
          )}
        </div>
        <div className='tw-33 summary_card min-hgt-55 remarks_tab'>
          <div className='rfstrckovrvw position-relative'>
            <h6>Remarks</h6>
            <p>Add and manage truck order notes</p>

            <button className='smllAddbtn absult_btn' onClick={addRemarks}><Plus /></button>
          </div>

          <Remarks propData={remarksData} onReload={handleReload} onEdit={(e) => { setEditData(e); setOpenModal(true) }} />
        </div>
      </div>
      <CommonModal
        show={openModal}
        onHide={modalClose}
        title={'New Remark - ' + propData?.truck_data?.truck_no + ' / ' + propData?.truck_data?.truck_date}
        subTitle='Add a new remark to the recovery case.'
        className='modal_bgw primary_modal'
        footer={
          <div className='d-flex'>
          </div>
        }>
        <RemarksForm propInfo={sendData} eData={editData} onReload={() => { handleReload(); setEditData() }} isModal={true} />
      </CommonModal>

      <DiscrepancyModal
        show={descrepencyModal}
        onHide={closeDescrepencyModal}
        truckData={selectedDiscrepancy}
        onReload={onReload}
        onDetails={onDetails}
      />
    </>
  )
}

export default Overview